// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__root-nU46mK","rootinteractive":"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__rootinteractive-dFWndV","dropSmoothCorners":"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__dropSmoothCorners-AQ7Q1q","dropSmoothCornersisRecording":"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__dropSmoothCornersisRecording-fj1HUK","svg":"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__svg-WDXtZj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__root-nU46mK\",\"rootinteractive\":\"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__rootinteractive-dFWndV\",\"dropSmoothCorners\":\"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__dropSmoothCorners-AQ7Q1q\",\"dropSmoothCornersisRecording\":\"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__dropSmoothCornersisRecording-fj1HUK\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_context_menu_indicator-PlasmicMenuIndicator-module__svg-WDXtZj\"}";
        // 1793541994230
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  